import Vue from 'vue';
import Vuex from 'vuex';
import app from './modules/app';
import accountSafety from './modules/account-safety';
import drivingBehaviorFeedback from './modules/driving-behavior-feedback';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    app,
    accountSafety,
    drivingBehaviorFeedback,
  },
});
